/**
 * Nicha Paris — Square Media Gallery (Vitals / vtls-media-gallery)
 * Slider + overlays — uniquement la 1re galerie produits de la homepage
 * Fin de fichier : NICHA_GALLERY_EOF 2026-06-03-fix28
 */
(function () {
  'use strict';

  const GALLERY_SELECTOR = 'vtls-media-gallery';
  const ITEM_SELECTOR = '.VtlsMediaGalleryImage';
  const PRODUCT_LINK_SELECTOR = 'a.VtlsMediaGalleryImage__Wrapper[href*="/products/"]';
  const INIT_ATTR = 'data-nicha-square-gallery';

  const productCache = new Map();
  let scanInProgress = false;

  const getShopifyRoot = () => {
    const root = window.Shopify?.routes?.root;
    if (root) return root.endsWith('/') ? root : `${root}/`;
    return '/';
  };

  const isEnglishLocale = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };

  const getCustomizableLabel = () => (isEnglishLocale() ? 'CUSTOMIZABLE' : 'PERSONNALISABLE');

  const getProductJsonUrl = (handle) =>
    `${getShopifyRoot()}products/${encodeURIComponent(handle)}.js`;

  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.theme && window.Shopify.theme.moneyFormat) ||
        '{{amount_with_comma_separator}} €';
      return Shopify.formatMoney(cents, format);
    }
    const amount = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  };

  const imageUrlWithWidth = (url, width) => {
    if (!url) return '';
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}width=${width}`;
  };

  const getHandleFromHref = (href) => {
    if (!href) return null;
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const fetchProduct = async (handle) => {
    const cacheKey = `${getShopifyRoot()}|${handle}`;
    if (productCache.has(cacheKey)) return productCache.get(cacheKey);
    const promise = fetch(getProductJsonUrl(handle))
      .then((res) => {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .catch(() => null);
    productCache.set(cacheKey, promise);
    return promise;
  };

  const isHomepage = () => {
    if (document.body.classList.contains('template-index')) return true;
    if (document.documentElement.classList.contains('template-index')) return true;
    if (document.body.classList.contains('nicha-homepage')) return true;
    const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '' || path === '/') return true;
    return /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  };

  const galleryHasProductTiles = (gallery) =>
    gallery && gallery.querySelector(`${ITEM_SELECTOR} ${PRODUCT_LINK_SELECTOR}`);

  const getPrimaryGallery = () => {
    if (!isHomepage()) return null;

    const scopedSelectors = [
      '#MainContent vtls-media-gallery',
      'main#MainContent vtls-media-gallery',
      'main vtls-media-gallery',
    ];

    for (const selector of scopedSelectors) {
      const galleries = document.querySelectorAll(selector);
      for (const gallery of galleries) {
        if (galleryHasProductTiles(gallery)) return gallery;
      }
    }

    for (const gallery of document.querySelectorAll(GALLERY_SELECTOR)) {
      if (galleryHasProductTiles(gallery)) return gallery;
    }

    return null;
  };

  const buildSlider = (item, product, link, img) => {
    const images =
      product.images && product.images.length
        ? product.images
        : [img.getAttribute('src')].filter(Boolean);

    if (images.length < 2) return;

    const normalize = (url) => (url || '').split('?')[0];
    const currentSrc = normalize(img.getAttribute('src'));
    let index = images.findIndex((src) => normalize(src) === currentSrc);
    if (index < 0) {
      const file = currentSrc.split('/').pop();
      index = images.findIndex((src) => normalize(src).endsWith(file));
    }
    if (index < 0) index = 0;

    let card = item.querySelector(':scope > .nicha-gallery-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'nicha-gallery-card';
      link.parentNode.insertBefore(card, link);
      card.appendChild(link);
    }

    if (item.querySelector('.nicha-gallery-arrow--prev')) return;

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'nicha-gallery-arrow nicha-gallery-arrow--prev';
    prev.setAttribute('aria-label', isEnglishLocale() ? 'Previous image' : 'Image précédente');
    prev.innerHTML = '<span aria-hidden="true">&#10094;</span>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'nicha-gallery-arrow nicha-gallery-arrow--next';
    next.setAttribute('aria-label', isEnglishLocale() ? 'Next image' : 'Image suivante');
    next.innerHTML = '<span aria-hidden="true">&#10095;</span>';

    card.appendChild(prev);
    card.appendChild(next);

    const updateImage = () => {
      const src = images[index];
      img.src = imageUrlWithWidth(src, 800);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      link.setAttribute('data-fullsize', imageUrlWithWidth(src, 1600));
    };

    const go = (delta, event) => {
      event.preventDefault();
      event.stopPropagation();
      index = (index + delta + images.length) % images.length;
      updateImage();
    };

    prev.addEventListener('click', (e) => go(-1, e));
    next.addEventListener('click', (e) => go(1, e));

    item.classList.add('nicha-gallery-item--slider');
    item.dataset.nichaImageCount = String(images.length);
  };

  const buildOverlay = (item, product) => {
    if (item.querySelector('.nicha-gallery-overlay')) return;

    const link = item.querySelector(PRODUCT_LINK_SELECTOR);
    if (!link) return;

    const overlay = document.createElement('div');
    overlay.className = 'nicha-gallery-overlay';

    const badge = document.createElement('span');
    badge.className = 'nicha-gallery-badge';
    badge.textContent = getCustomizableLabel();

    const footer = document.createElement('div');
    footer.className = 'nicha-gallery-footer';

    const title = document.createElement('span');
    title.className = 'nicha-gallery-title';
    title.textContent = product.title;

    const price = document.createElement('span');
    price.className = 'nicha-gallery-price';
    const cents =
      product.price ||
      (product.variants && product.variants[0] && product.variants[0].price);
    price.textContent = formatMoney(cents);

    footer.appendChild(title);
    footer.appendChild(price);
    overlay.appendChild(badge);
    overlay.appendChild(footer);
    link.appendChild(overlay);
  };

  const getPrimaryGalleryCols = (root) =>
    window.matchMedia('(min-width: 990px)').matches
      ? Number(root.getAttribute('data-columns-desktop')) || 4
      : Number(root.getAttribute('data-columns-mobile')) || 2;

  const measurePrimaryTileMetrics = (root) => {
    const items = [...root.querySelectorAll(ITEM_SELECTOR)];
    if (!items.length) return null;

    const gap = Number(root.getAttribute('data-gap')) || 12;
    const cols = getPrimaryGalleryCols(root);
    const rowCount = Math.ceil(items.length / cols);
    const list = root.querySelector('.VtlsMediaGalleryImages');
    const container = root.querySelector('.VtlsMediaGalleryContainer');
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;

    const firstImg = items[0].querySelector('img.VtlsMediaGalleryImage__Image, img');
    const aspect =
      firstImg && firstImg.naturalWidth > 0 && firstImg.naturalHeight > 0
        ? firstImg.naturalHeight / firstImg.naturalWidth
        : 1;

    if (isDesktop && container) {
      const trackW = container.getBoundingClientRect().width;
      if (trackW > 40) {
        const tileWidth = (trackW - gap * Math.max(0, cols - 1)) / cols;
        const tileHeight = Math.max(tileWidth * aspect, tileWidth);
        root.dataset.nichaUniformBaseW = String(Math.round(tileWidth));
        root.dataset.nichaUniformBaseH = String(Math.round(tileHeight));
        return { items, gap, cols, rowCount, list, container, tileWidth, tileHeight, isDesktop };
      }
    }

    let tileWidth = 0;
    let tileHeight = 0;

    items.forEach((item) => {
      const w = item.offsetWidth || item.getBoundingClientRect().width;
      const h = item.offsetHeight || item.getBoundingClientRect().height;
      if (w > tileWidth) tileWidth = w;
      if (h > tileHeight) tileHeight = h;
    });

    if (list) {
      const listW = list.getBoundingClientRect().width;
      if (listW > 0 && cols > 0) {
        const inferredW = (listW - gap * Math.max(0, cols - 1)) / cols;
        if (inferredW > 0) tileWidth = inferredW;
      }
    }

    if (!tileWidth) return null;
    if (!tileHeight || tileHeight < 40) tileHeight = tileWidth * aspect;

    root.dataset.nichaUniformBaseW = String(Math.round(tileWidth));
    root.dataset.nichaUniformBaseH = String(Math.round(tileHeight));

    return { items, gap, cols, rowCount, list, container, tileWidth, tileHeight, isDesktop };
  };

  const uniformTileSizes = (root) => {
    if (!root || !root.isConnected) return;

    const metrics = measurePrimaryTileMetrics(root);
    if (!metrics) return;

    let { items, gap, cols, rowCount, list, container, tileWidth, tileHeight } = metrics;

    if (metrics.isDesktop && container) {
      const trackW = container.getBoundingClientRect().width;
      if (trackW > 40) {
        tileWidth = (trackW - gap * Math.max(0, cols - 1)) / cols;
        const firstImg = items[0].querySelector('img.VtlsMediaGalleryImage__Image, img');
        const aspect =
          firstImg && firstImg.naturalWidth > 0 && firstImg.naturalHeight > 0
            ? firstImg.naturalHeight / firstImg.naturalWidth
            : 1;
        tileHeight = Math.max(tileWidth * aspect, tileWidth);
      }
    }

    const applyTiles = (w, h) => {
      items.forEach((item, index) => {
        const col = index % cols;
        const row = Math.floor(index / cols);
        item.style.setProperty('width', `${w}px`, 'important');
        item.style.setProperty('height', `${h}px`, 'important');
        item.style.setProperty('left', `${col * (w + gap)}px`, 'important');
        item.style.setProperty('top', `${row * (h + gap)}px`, 'important');
        item.style.setProperty('position', 'absolute', 'important');
      });
    };

    applyTiles(tileWidth, tileHeight);

    let totalWidth = cols * tileWidth + Math.max(0, cols - 1) * gap;

    if (list) {
      const totalHeight = rowCount * tileHeight + Math.max(0, rowCount - 1) * gap;
      list.style.setProperty('position', 'relative', 'important');
      list.style.setProperty('width', `${Math.round(totalWidth)}px`, 'important');
      list.style.setProperty('max-width', '100%', 'important');
      list.style.setProperty('height', `${Math.round(totalHeight)}px`, 'important');
      list.style.setProperty('margin-left', 'auto', 'important');
      list.style.setProperty('margin-right', 'auto', 'important');
      list.style.setProperty('overflow', 'visible', 'important');
    }

    if (container && metrics.isDesktop) {
      ['width', 'max-width', 'margin-left', 'margin-right', 'padding-left', 'padding-right'].forEach(
        (prop) => container.style.removeProperty(prop)
      );
      container.style.setProperty('overflow', 'visible', 'important');
    }

    root.classList.add('nicha-gallery--uniform');
    document.dispatchEvent(new CustomEvent('nicha:primary-gallery-layout'));
  };

  const watchPrimaryGalleryImages = (root) => {
    if (root.dataset.nichaPrimaryImgWatch === 'true') return;
    root.dataset.nichaPrimaryImgWatch = 'true';

    root.querySelectorAll('img.VtlsMediaGalleryImage__Image, img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        'load',
        () => uniformTileSizes(root),
        { once: true }
      );
    });
  };

  const enhanceItem = async (item, root) => {
    if (!root || !root.contains(item)) return;

    const state = item.getAttribute(INIT_ATTR);
    if (state === 'true' || state === 'pending') return;

    const link = item.querySelector(PRODUCT_LINK_SELECTOR);
    if (!link) return;

    const handle = getHandleFromHref(link.getAttribute('href'));
    if (!handle) return;

    const img = link.querySelector('img.VtlsMediaGalleryImage__Image, img');
    if (!img) return;

    item.setAttribute(INIT_ATTR, 'pending');

    const product = await fetchProduct(handle);
    if (!product) {
      item.setAttribute(INIT_ATTR, 'error');
      return;
    }

    item.setAttribute(INIT_ATTR, 'true');
    item.classList.add('nicha-gallery-item');

    buildOverlay(item, product);
    buildSlider(item, product, link, img);
  };

  const resetFailedGalleryItems = (root) => {
    root.querySelectorAll(`${ITEM_SELECTOR}[${INIT_ATTR}="error"]`).forEach((item) => {
      item.removeAttribute(INIT_ATTR);
      item.classList.remove('nicha-gallery-item', 'nicha-gallery-item--slider');
      item.querySelector('.nicha-gallery-overlay')?.remove();
      item.querySelector('.nicha-gallery-arrow--prev')?.remove();
      item.querySelector('.nicha-gallery-arrow--next')?.remove();
      const card = item.querySelector('.nicha-gallery-card');
      const link = item.querySelector(PRODUCT_LINK_SELECTOR);
      if (card && link && card.contains(link)) {
        card.parentNode.insertBefore(link, card);
        card.remove();
      }
    });
  };

  const enhanceAllItems = async (root) => {
    resetFailedGalleryItems(root);
    const items = [...root.querySelectorAll(ITEM_SELECTOR)].filter((item) =>
      item.querySelector(PRODUCT_LINK_SELECTOR)
    );
    await Promise.all(items.map((item) => enhanceItem(item, root)));
  };

  const scan = async () => {
    if (!isHomepage() || scanInProgress) return;

    scanInProgress = true;
    try {
      document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {
        gallery.classList.remove('nicha-gallery--primary');
        gallery.removeAttribute('data-nicha-primary-gallery');
      });

      const root = getPrimaryGallery();
      if (!root) return;

      root.classList.add('nicha-gallery--primary');
      root.setAttribute('data-nicha-primary-gallery', 'true');

      await enhanceAllItems(root);

      watchPrimaryGalleryImages(root);
      uniformTileSizes(root);
      setTimeout(() => uniformTileSizes(root), 800);

      if (root.dataset.nichaUniformResize !== 'true') {
        root.dataset.nichaUniformResize = 'true';
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            delete root.dataset.nichaUniformBaseW;
            delete root.dataset.nichaUniformBaseH;
            uniformTileSizes(root);
          }, 200);
        });
      }
    } catch (err) {
      console.error('[Nicha] square gallery scan error', err);
    } finally {
      scanInProgress = false;
    }
  };

  const init = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    scan().catch(() => {});
    [600, 2000, 4500].forEach((delay) => setTimeout(() => scan().catch(() => {}), delay));
  };

  init();

  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => scan().catch(() => {}));
  }

  window.NichaSquareMediaGallery = { scan, getPrimaryGallery };
})();

/* NICHA_GALLERY_EOF 2026-06-03-fix28 */
